import { useDispatch } from "react-redux";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import {
  setBottomSheetSource,
  setBottomSheetState,
} from "../../../../services/redux/slices/globalComponentsToggleSlice";
import styles from "./SelectOrderBanner.module.scss";

type SelectOrderBannerProps = {
  bgColor: "primary" | "loyalty";
  bannerText: string;
  icon: React.ReactNode;
};

function SelectOrderBanner({
  bgColor,
  bannerText,
  icon,
}: SelectOrderBannerProps) {
  const { t } = useTranslationI18();
  const dispatch = useDispatch();

  return (
    <div className={styles.banner_wrapper} data-testid="select-order-banner">
      <div
        className={`${styles.offer_icon} ${
          bgColor === "loyalty" && styles.loyalty
        }`}
      >
        {icon}
      </div>
      <div
        className={`${styles.select_order_info_banner} ${
          bgColor === "primary" ? styles.primary_bg : styles.loyalty_bg
        }`}
      >
        <p
          className={bgColor !== "primary" ? styles.dark_text : ""}
          dangerouslySetInnerHTML={{ __html: bannerText }}
        />
        <button
          onClick={() => {
            dispatch(setBottomSheetSource("banner_selection"));
            dispatch(setBottomSheetState(true));
          }}
          data-testid="select-order-banner-button"
        >
          {t("common:select-now")}
        </button>
      </div>
    </div>
  );
}

export default SelectOrderBanner;
